/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Role } from '../models/Role';

export class ListRolesResponse {
  'roles': Array<Role>;
  /**
  * Total number of roles.
  */
  'totalCount'?: number;
  'nextToken'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "roles",
      "baseName": "roles",
      "type": "Array<Role>",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListRolesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

